module.exports = __webpack_public_path__ + "static/p11-38f3b51aa05457dbdfc1d4e266b0fd3d.jpg";